import React, { useMemo } from 'react'
import { Link, useHistory } from 'react-router-dom'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import { useSearchStatusTemplates } from '../../../../../api/groups'
import OperationalTable from '../../../../organisms/OperationalTable'
import { ADMIN_ROUTES } from '../../../../../constants'

const cellTemplates = {
  link: (accessor) => ({ row }) => (
    <Link
      onClick={(event) => event.stopPropagation()}
      to={`${ADMIN_ROUTES.STATUS_TEMPLATE_DETAILS}/${row.original.statusTemplateId}`}
    >
      {accessor(row.original) || 'Link'}
    </Link>
  )
}

export const defaultColumnConfig = {
  columns: [
    { Header: 'Id', accessor: 'statusTemplateId', type: 'number', Cell: cellTemplates.link(row => row.statusTemplateId) },
    { Header: 'Name', accessor: 'name', type: 'string', Cell: cellTemplates.link(row => row.name) },
    { Header: 'Description', accessor: 'description', type: 'string' }
  ],
  defaultSort: [{ id: 'statusTemplateId', desc: false }]
}

function TemplatesListTab () {
  const query = useMemo(() => {
    return { take: 200 }
  }, [])
  const history = useHistory()
  const { data, isLoading } = useSearchStatusTemplates(query)

  return (
    <FadeIn style={{ marginTop: '20px' }}>
      <OperationalTable
        variant='v2'
        mode='client'
        itemName='Status Report Templates'
        data={data?.data || []}
        loading={isLoading}
        total={data?.data?.length}
        columns={defaultColumnConfig.columns}
        defaultSort={defaultColumnConfig.defaultSort}
        onRowClick={(row) => history.push(`${ADMIN_ROUTES.STATUS_TEMPLATE_DETAILS}/${row.original.statusTemplateId}`)}
      />
    </FadeIn>
  )
}

TemplatesListTab.propTypes = {
}

TemplatesListTab.defaultProps = {
}

export default TemplatesListTab
